interface Props {
  content: string;
  className?: string;
}

// Seul composant d'affichage des champs de texte long depuis l'issue #369. Rien n'y est interprété,
// donc rien n'est à désinfecter — React échappe ce qu'il affiche. `whitespace-pre-line` restitue les
// sauts de ligne de l'auteur et écrase les espaces multiples, exactement ce que produit la conversion
// côté serveur.
export const PlainTextContent = ({ content, className = "" }: Props) => (
  <div className={`whitespace-pre-line break-words ${className}`}>{content}</div>
);
